import * as Timer from './timer';
import * as Http from './http';
import * as Location from './location';

export default {
    Timer,
    Http,
    Location,
};
